import PropTypes from "prop-types"
import React from "react"

import Stanwood from "./stanwood"

class ConfirmationScreen extends React.Component {
  constructor(props) {
    super(props)

    this.handleContinue = this.handleContinue.bind(this)
  }

  componentDidMount() {
    const {
      productInformation: { dockwa_plus_external_id },
    } = this.props

    Amplitude.trackEvent("dockwa_plus:welcome_screen_viewed", {
      dockwa_plus_external_id,
    })
  }

  handleContinue() {
    const {
      onClose,
      productInformation: { dockwa_plus_external_id },
    } = this.props

    Amplitude.trackEvent("dockwa_plus:continue_reservation_pressed", {
      dockwa_plus_external_id,
    })

    onClose()
  }

  render() {
    const { user } = this.props

    return (
      <div className="my-4 flex flex-col items-center gap-4">
        <h3 className="m-0 font-bold">Membership Confirmed</h3>
        <Stanwood />
        <div className="text-center">
          Welcome aboard! You are now an official Dockwa+ member.
          <br />
          We&apos;ve emailed you a confirmation to {user.email}
        </div>
        <button
          type="button"
          className="btn btn-primary m-4"
          onClick={this.handleContinue}
        >
          Continue with Reservation
        </button>
      </div>
    )
  }
}

ConfirmationScreen.propTypes = {
  productInformation: PropTypes.shape({
    dockwa_plus_external_id: PropTypes.string,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  user: PropTypes.shape({
    email: PropTypes.string,
  }).isRequired,
}

export default ConfirmationScreen
